module.exports = __webpack_public_path__ + "static/media/Results.1766a8e5.wav";